// Schreiben-Assistent (#586): gemeinsame Typen. Spec: docs/superpowers/specs/2026-10-31-schreiben-assistent-design.md

/** #587: Zustellwege, mehrere je Empfänger möglich. Etappe 3: „druck“ = Druckstapel fürs Büro (selbst versenden). */
export type Zustellweg = 'email' | 'post' | 'portal' | 'druck';
export const ZUSTELLWEGE: Zustellweg[] = ['email', 'post', 'portal', 'druck'];
/** Als bevorzugter Weg am Kontakt wählbar (Druck nicht – der entscheidet sich je Schreiben) */
export const KONTAKT_ZUSTELLWEGE: Zustellweg[] = ['email', 'post', 'portal'];
export const ZUSTELLWEG_LABEL: Record<Zustellweg, string> = { email: 'E-Mail', post: 'Post', portal: 'Portal', druck: 'Druck' };
export type EmpfaengerArt = 'mieter' | 'eigentuemer' | 'kontakt' | 'dienstleister';

export interface SchreibenEmpfaenger {
  art: EmpfaengerArt;
  id: string;
  name: string;
  /** Anschrift fürs Fenster, letzte Zeile „PLZ Ort“ (leer = keine Postanschrift) */
  anschrift: string;
  email: string | null;
  /** #587: bevorzugte Zustellwege aus den Stammdaten (leer = automatisch) */
  zustellwege: Zustellweg[];
  /** hat einen Portalzugang (nur Mieter/Eigentümer) */
  portal: boolean;
  /** Etappe 3: Sperrvermerk am Kontakt – gesetzt = nichts senden */
  sperrvermerk?: string | null;
  objektId: string | null;
  einheitId: string | null;
  /** Ordnername-Anfang für die Ablage („Berg, Anna“) */
  ordnerName: string | null;
  /** Platzhalter-Werte dieses Empfängers ({{gruppe.feld}}) */
  werte: Record<string, string>;
}

/** Etappe 5: janein (Ja/Nein) und auswahl (Liste aus „auswahl:A/B/C“ → optionen) */
export interface EingabeFeld {
  schluessel: string; beschriftung: string; typ: 'text' | 'datum' | 'betrag' | 'janein' | 'ankreuzen' | 'auswahl'; optionen?: string[];
  /** #592: Vorbelegung – Datenfeld (gruppe.feld, je Empfänger) oder fester Wert */
  vor?: string;
}

export interface SchreibenAnlage { name: string; mime: string; drive?: string; storage?: { bucket: string; path: string } }

export const ZIELGRUPPEN: [string, string][] = [
  ['mieter', 'Mieter'], ['eigentuemer', 'Eigentümer'], ['weg', 'WEG'], ['handwerker', 'Handwerker'], ['allgemein', 'Allgemein'],
];

/** Höchstens so viele Empfänger je Lauf; größere Rundschreiben über den Serienmail-Assistenten. */
export const MAX_EMPFAENGER = 100;
